import { graphql } from '@graphql/__generated'

export const MANAGE_RECORDING = graphql(`
  mutation manageRecording($channelName: String!, $action: String!) {
    manageRecording(channelName: $channelName, action: $action)
  }
`)
